import React, { useState } from 'react';

import { register, errorMessage } from '../api';
import { COUNTRIES, DEFAULT_COUNTRY, OTHER_COUNTRY, flag } from '../countries';

const Register = ({ onRegistered }) => {
  const [country, setCountry] = useState(DEFAULT_COUNTRY);
  const [customCode, setCustomCode] = useState('');
  const [phone, setPhone] = useState('');
  const [nickname, setNickname] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const selected = COUNTRIES.find(({ iso }) => iso === country);
  const countryCode = selected ? selected.code : customCode.replace(/\D/g, '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const data = await register(countryCode, phone, nickname);
      onRegistered({
        sessionToken: data.sessionToken,
        participant: data.participant,
        returning: data.returning,
      });
    } catch (err) {
      setError({ message: errorMessage(err), field: err.response?.data?.field });
      setSubmitting(false);
    }
  };

  const fieldError = (field) =>
    error?.field === field && <p className='field__error'>{error.message}</p>;

  return (
    <div className='register'>
      <form className='register__card' onSubmit={handleSubmit} noValidate>
        <h1 className='register__title'>Chat del evento</h1>
        <p className='register__subtitle'>
          Ingresá tu celular y un nickname para entrar al chat y participar de los sorteos.
        </p>

        <div className='field'>
          <label htmlFor='phone'>Celular</label>
          <div className='phone'>
            {/* The native select sits invisible on top, so phones open their own picker */}
            <div className='phone__country'>
              <span className='input phone__country-value' aria-hidden='true'>
                {selected ? `${flag(selected.iso)} +${selected.code}` : '🌐 Otro'}
              </span>
              <select aria-label='País' value={country} onChange={(e) => setCountry(e.target.value)}>
                {COUNTRIES.map(({ iso, name, code }) => (
                  <option key={iso} value={iso}>
                    {flag(iso)} {name} (+{code})
                  </option>
                ))}
                <option value={OTHER_COUNTRY}>🌐 Otro país</option>
              </select>
            </div>
            {!selected && (
              <input
                className='input phone__code'
                type='tel'
                inputMode='numeric'
                autoComplete='tel-country-code'
                aria-label='Código de país'
                placeholder='+000'
                maxLength={4}
                value={customCode}
                onChange={(e) => setCustomCode(e.target.value)}
                autoFocus
              />
            )}
            <input
              id='phone'
              className='input phone__number'
              type='tel'
              inputMode='numeric'
              autoComplete='tel-national'
              placeholder={selected?.iso === DEFAULT_COUNTRY ? 'Ej: 71234567' : 'Número sin código de país'}
              maxLength={20}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              autoFocus
            />
          </div>
          {fieldError('phone')}
        </div>

        <div className='field'>
          <label htmlFor='nickname'>Nickname</label>
          <input
            id='nickname'
            className='input'
            type='text'
            autoComplete='nickname'
            placeholder='Cómo te verán en el chat'
            maxLength={20}
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
          />
          {fieldError('nickname')}
        </div>

        {error && !error.field && <p className='form-error'>{error.message}</p>}

        <button
          type='submit'
          className='btn-primary'
          disabled={submitting || !countryCode || !phone.trim() || !nickname.trim()}
        >
          {submitting ? 'Entrando…' : 'Entrar'}
        </button>

        <p className='register__hint'>
          ¿Ya te registraste? Ingresá el mismo celular y volvés con tu nickname.
        </p>
      </form>
    </div>
  );
};

export default Register;
